import { render, staticRenderFns } from "./ViewMember.vue?vue&type=template&id=2371944c&scoped=true"
import script from "./ViewMember.vue?vue&type=script&lang=js"
export * from "./ViewMember.vue?vue&type=script&lang=js"
import style0 from "./ViewMember.vue?vue&type=style&index=0&id=2371944c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2371944c",
  null
  
)

export default component.exports